import axios from "axios";
import React, { useRef, useState } from "react";
import { AiFillPrinter } from "react-icons/ai";
import ReactToPrint from "react-to-print";
import { useGetProductQuery } from "../../../features/api/productApi";
import { useGetDealersQuery } from "../../../features/api/dealerApi";
import { useGetInvoicesQuery } from "../../../features/api/orderinvoiceApi";
import { API_BASE_URL } from "../../../components/baseUrl";

const DailySalesReport = () => {
  const componentRef = useRef();

  const startDate = new Date();
  let startDay = startDate.getDate();
  let startSmonth = startDate.getMonth() + 1;
  let startYear = startDate.getFullYear();
  let getStartDate = startYear + "-" + startSmonth + "-" + startDay;
  let todaysDate = startDay + "-" + startSmonth + "-" + startYear;

  const [sales, setSales] = useState([]);
  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/ordersDate?startDate=${getStartDate}&endDate=${getStartDate}`
      );
      console.log(response);
      if (response) {
        setSales(response?.data?.sales);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const { data: prod } = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const products = prod?.products;

  const { data, error, isLoading } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = data?.dealer;

  const { data: ordrs2 } = useGetInvoicesQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const orders2 = ordrs2?.orders_twos;

  const grandTotal = sales?.reduce((sum, data) => sum + data?.total, 0);
  const totalQuantity = sales?.reduce((sum, data) => sum + data?.qty, 0);

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }
  return (
    <div className="w-full max-w-[1280px] mx-auto px-6 md:px-auto h-[90vh] overflow-auto">
      <h1 className="font-bold text-xl my-4">Daily Sales report</h1>
      <div>
        <div className="flex items-center">
          <button
            onClick={handleSearch}
            className="px-2 py-1 bg-indigo-900 text-white font-bold rounded-sm"
          >
            View
          </button>
          <ReactToPrint
            trigger={() => (
              <h1 className="cursor-pointer flex items-center m-1 absolute right-6 ">
                <AiFillPrinter />
                print
              </h1>
            )}
            content={() => componentRef.current}
            pageStyle="@page {  margin: 0.5cm; }  }"
          />
        </div>
        <div ref={componentRef}>
          {sales?.length > 0 && (
            <div className="">
              <div className="flex flex-col  ">
                <div className="flex justify-center my-8 relative">
                  <div className="text-center text-sm mt-2">
                    <h2 className="font-bold">Johura Endomed Solution</h2>
                    <p>
                      {" "}
                      15/A, Zigatola, Hafizullah Green Tower, Flat # C1
                      Dhanmondi, Dhaka - 1209
                    </p>
                    <p>+88 01711 071102</p>
                    <p>+88 01977 071102</p>
                    <p>
                      <span className="">Email:</span> jahangirjohura@gmail.com
                    </p>
                  </div>
                </div>
                <p className="pb-2 text-center">
                  Daily Sales Report: {todaysDate}
                </p>
                <div className=" mb-3 border-b border-gray-400 "></div>
                <div>
                  <table className="min-w-full bg-white">
                    <thead>
                      <tr>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                          Sl No.
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                          Invoice No.
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                          Invoice Date
                        </th>
                        {/* <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                          Supplier
                        </th> */}
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                          Client
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                          Product
                        </th>

                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                          Quantity
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                          Unit Rate
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                          Total Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {sales?.map((data, index) => {
                        const proName = products?.find(
                          (pro) => pro?.id === data?.pro_name
                        );
                        const exists = orders2?.find(
                          (exist) => exist?.inv_no === data?.inv_no
                        );
                        const dealerName = dealers?.find(
                          (dlr) => dlr?.id === +exists?.dealer
                        );

                        return (
                          <tr key={index}>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {index + 1}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.inv_no}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {formatDate(data?.inv_date)}
                            </td>
                            {/* <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                          {data?.supp_name}
                        </td> */}
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {dealerName?.d_name}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {proName?.product_name}
                            </td>

                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.qty}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.sales_rate}
                            </td>
                            <td className="text-center px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.total}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <thead>
                      <tr>
                        <th
                          colSpan={4}
                          className="px-6 py-3 border-b-2 border-gray-300 text-right text-xs font-semibold uppercase tracking-wider"
                        >
                          Total Quantity:
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-center text-xs font-semibold uppercase tracking-wider">
                          {totalQuantity}
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-right text-xs font-semibold uppercase tracking-wider">
                          Total:
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-centerc text-xs font-semibold uppercase tracking-wider">
                          {grandTotal}
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div className="flex justify-end mt-16">
                  <p className="border-t border-t-black">
                    Authorised Signature
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DailySalesReport;
